import { arch, platform, release, type } from "os";
import { Signer } from "@flixxo/authorizator";
import packageInfo from "../../../package.json";
import FlixxoApiClient from "./flixxoApiClient";
import i18n from "i18n";
import { environment } from "config/environment";

let authToken = null;

const API_URL = environment.apiUrl;
const OSINFO = `${platform()}; ${type()} ${arch()} ${release()}`;
const ENV = environment.name;
const AGENT =
  `${packageInfo.build.appId}/${packageInfo.version} ` +
  `(${OSINFO}) ${packageInfo.name} (${ENV}) ` +
  `node/${process.versions.node} ` +
  `chrome/${process.versions.chrome} ` +
  `v8/${process.versions.v8} `;
  
const lang = i18n.language

export class UnauthApiClient extends FlixxoApiClient {
  constructor() {
    super(`${API_URL}/api`, {
      headers: {
        "X-Flixxo-Client": AGENT,
        "x-flixxo-lang": lang,
      },
    });
  }
}

export default class ApiClient extends UnauthApiClient {
  constructor() {
    super();
    const secret = window.localStorage.getItem('secret')
    this._signer = new Signer(secret);
  }

  async fetch(route, method = "GET", body = null, options = {}) {
    let ronly = route.replace(/\?[\s\S]*$/g, "");
    authToken = await this._signer.generateToken(ronly);
    const hasQuery = method === "GET" || method === "DELETE";
    return super.fetch(route, method, body, hasQuery, {
      ...options,
      ...(options.headers || {}),
      Authorization: createHeader(authToken.toString()),
    });
  }
}

function createHeader(authToken) {
  return `Basic ${btoa(authToken)}`;
}
